import type {
  AgentPresentation,
  AgentPresentationStep,
} from "./agent-presentation-types";
import type { PresentationStepReceipt } from "./presentation-step-progress";

const receipts = new Map<
  string,
  { attempt: number; steps: Map<string, PresentationStepReceipt> }
>();
const keyFor = (p: AgentPresentation) =>
  JSON.stringify([p.executionId, p.presentationId]);
export function rememberPresentationComponent(
  p: AgentPresentation,
  step: AgentPresentationStep,
  component: "visual" | "speech" | "user_action" | "step",
  state: string,
): void {
  const key = keyFor(p);
  let record = receipts.get(key);
  const attempt = p.playbackAttempt ?? 1;
  if (record && record.attempt > attempt) return;
  if (!record) {
    record = { attempt, steps: new Map() };
    receipts.set(key, record);
  }
  record.attempt = attempt;
  const steps = record.steps;
  const receipt = steps.get(step.step_id) ?? { step_id: step.step_id };
  receipt[component] = state;
  steps.set(step.step_id, receipt);
  if (receipts.size > 128) receipts.delete(receipts.keys().next().value!);
}
export function mergePresentationReceipts(
  p: AgentPresentation,
): AgentPresentation {
  if (!p.resumeReceipt) return p;
  const local = receipts.get(keyFor(p));
  if (!local) return p;
  local.attempt = Math.max(local.attempt, p.playbackAttempt ?? 1);
  return {
    ...p,
    resumeReceipt: p.steps.map((step) => {
      const server = p.resumeReceipt?.find(
        (item) => item.step_id === step.step_id,
      );
      const receipt = { step_id: step.step_id, ...server };
      const cached = local.steps.get(step.step_id);
      for (const component of ["visual", "speech", "user_action"] as const) {
        const state = cached?.[component];
        if (state === "finished" || state === "rendered" || state === "skipped")
          receipt[component] = state;
      }
      return receipt;
    }),
  };
}
